// export const POSDBName = "POSDB";
export const POSDBName = "smeetz-db";

export enum CollectionName {
  POSConfigs = "posconfigs",
  ProductCategories = "productcategories",
  Timeslots = "timeslots",
  ProductSlotBookings = "productslotbookings",
  ProductSlotStates = "productslotstates",
  CashFloats = "cashfloats",
  PosLogs = "poslogs",
  PosFiles = "posfiles",
  UpdatedBookings = "updatedbookings",
  UntypedBookings = "untypedbookings",
  CashTransfers = "cashtransfers",
  Transactions = "transactions",
  UntypedTransactions = "untypedtransactions",
  ReceiptCountersPayloadID = "receiptcounters",
}

export const SiteLanguages = ["en", "fr", "de", "it", "es"] as const;

export const DEFAULT_LANG = "en";

// Memory usage threshold in MB
export const MEMORY_USAGE_THRESHOLD = 500;
